import React, { useEffect } from "react";
import { Form, Input, DatePicker, Col, Row, Space, Tabs } from "antd";
import { TeamOutlined } from "@ant-design/icons";
import { getAllUsersToSelect } from "Api/UsersApi/helpers";
import { ChooseWorks } from "../ChooseWorks/ChooseWorks";
import { useDispatch, useSelector } from "react-redux";
import {
  selectBlank,
  setChangeMaterialsValue,
  setChangeValue,
  setCommentData,
  setDate,
  setDescription,
  setSelectedMaterials,
  setSelectedWorks,
  setUsers,
  setWorkTime,
} from "AppStore/Slices/BlankSlice/BlankSlice";
import dayjs from "dayjs";
import { SearchSelectDebounce } from "Components/SearchSelectDebounce/SearchSelectDebounce";
import { MyText } from "Components/MyText/MyText";
import { MyTimePicker } from "Components/MyTimePicker/MyTimePicker";
import { getAllMaterialsForProjectToSelect } from "Api/ProjectApi/helpers";
import { useDroppable } from "@dnd-kit/core";
import { defaultSettings } from "css/defaultAntStyles";
const { TextArea } = Input;

export const EditBlankForm = ({
  form,
  onFinish,
  disabled = false,
  activeItem = null,
}) => {
  const {
    blankMaterials,
    description,
    workDate,
    users,
    selectedWorks,
    startTime,
    endTime,
  } = useSelector(selectBlank);
  const dispatch = useDispatch();

  const worksDrop = useDroppable({
    id: "works-drop-edit",
    data: {
      type: "works",
    },
  });

  // Вкладка Матеріали
  const materialsDrop = useDroppable({
    id: "materials-drop-edit",
    data: {
      type: "materials",
    },
  });

  const { setNodeRef: setWorksNodeRef, isOver: isWorksOver } = worksDrop;

  const { setNodeRef: setMaterialsNodeRef, isOver: isMaterialsOver } =
    materialsDrop;

  return (
    <Form layout="vertical" form={form} onFinish={onFinish}>
      <Col span={24}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Час виконання робіт" name="workTime">
              <Space>
                <MyTimePicker
                  disabled={disabled}
                  placeholder={"Старт робіт"}
                  onChange={(time) =>
                    dispatch(setWorkTime({ param: "startTime", time }))
                  }
                  value={startTime}
                />
                <MyTimePicker
                  disabled={disabled}
                  placeholder={"Кінець робіт"}
                  onChange={(time) =>
                    dispatch(setWorkTime({ param: "endTime", time }))
                  }
                  value={endTime}
                />
              </Space>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Дата виконання">
              <DatePicker
                disabled={disabled}
                style={{ width: "100%" }}
                format="DD.MM.YYYY"
                placeholder="Оберіть дату"
                value={workDate ? dayjs(workDate) : null}
                onChange={(e) => dispatch(setDate(e ? e.toISOString() : ""))}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <MyText
              type="primary"
              text={"Виберіть працівників що виконували роботу"}
            />
            <SearchSelectDebounce
              disabled={disabled}
              prefix={<TeamOutlined />}
              onChange={(e) => {
                const userIds = (Array.isArray(e) ? e : [])
                  .filter(Boolean)
                  .map((el) => el?.value ?? el)
                  .filter(Boolean);
                const usersData = userIds.map((user) => {
                  const json = user.split("___")[0];
                  const raw = JSON.parse(json);
                  return raw;
                });

                dispatch(setUsers(usersData));
              }}
              customFetch={getAllUsersToSelect}
              mode="multiple"
              value={users.map((el) => {
                return {
                  value: JSON.stringify(el) + `___` + el.id,
                  label: el.name,
                };
              })}
            />
          </Col>
          <Col span={12}>
            <Form.Item label="Опис робіт">
              <TextArea
                disabled={disabled}
                rows={4}
                placeholder="Опишіть виконані або заплановані роботи"
                value={description}
                onChange={(e) => dispatch(setDescription(e.target.value))}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Tabs
              className="my-custom-materials-tabs"
              defaultActiveKey="1"
              items={[
                {
                  label: `Виберіть роботи`,
                  key: 1,
                  children: (
                    <div
                      ref={!disabled ? setWorksNodeRef : null}
                      style={{
                        border:
                          isWorksOver &&
                          activeItem.type === "works" &&
                          `2px solid ${defaultSettings.colorPrimary}`,
                        padding: isWorksOver && "20px",
                        borderRadius: isWorksOver && "20px",
                      }}
                    >
                      <ChooseWorks
                        title=""
                        disabled={disabled}
                        onChange={(worksData) =>
                          dispatch(setSelectedWorks(worksData))
                        }
                        changeValue={(value) => dispatch(setChangeValue(value))}
                        changeComment={(commentData) => {
                          dispatch(setCommentData(commentData));
                        }}
                        selectedWorks={selectedWorks}
                      />
                    </div>
                  ),
                },
                {
                  label: `Матеріали`,
                  key: 2,
                  children: (
                    <div
                      ref={!disabled ? setMaterialsNodeRef : null}
                      style={{
                        border:
                          isMaterialsOver && activeItem.type === "materials"
                            ? `2px solid ${defaultSettings.colorPrimary}`
                            : undefined,
                        padding: isMaterialsOver ? "20px" : undefined,
                        borderRadius: isMaterialsOver ? "20px" : undefined,
                      }}
                    >
                      <ChooseWorks
                        title=""
                        disabled={disabled}
                        findMaterials={true}
                        fetchFunction={getAllMaterialsForProjectToSelect}
                        onChange={(materialsData) => {
                          dispatch(setSelectedMaterials(materialsData));
                        }}
                        changeValue={(value) =>
                          dispatch(setChangeMaterialsValue(value))
                        }
                        changeComment={(commentData) => {
                          dispatch(setCommentData(commentData));
                        }}
                        selectedWorks={blankMaterials}
                        placeholder="Пошук матеріалів..."
                      />
                    </div>
                  ),
                },
              ]}
            />
          </Col>
          {/* <Col span={24}>
            <ChooseWorks
              disabled={disabled}
              onChange={(worksData) => dispatch(setSelectedWorks(worksData))}
              changeValue={(value) => dispatch(setChangeValue(value))}
              selectedWorks={selectedWorks}
            />
          </Col> */}
        </Row>
      </Col>
    </Form>
  );
};
